import React from 'react'
import { requestSectionPrecedents } from 'services/PrecedentsService'
import { filter } from 'rxjs/operators'
import { forEach, includes, result, get } from 'libraries/lodash'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import useObservable from 'front-end-core/hooks/useObservable'
import PrecedentsReviewSections from './PrecedentsReviewSections'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import ResponseConsumer from 'pages/share/Main'

export default ({ precedentIds, sectionId, title, category, aol }) => {
  const response = useObservable(
    requestSectionPrecedents(
      category === 'browse' ? 'precedents' : category,
      sectionId,
      aol
    ).pipe(filter(isValidResponse)),
    RESPONSE_PENDING
  )
  const nodes = result(response, 'nodes')
  const sectionTitle = result(response, [
    'nodes',
    (response || {}).sectionId,
    'title'
  ])
  const filteredParents = {}
  forEach(get(response, 'parents', []), (fileIds, parentId) => {
    filteredParents[parentId] = fileIds.filter(id => includes(precedentIds, id))
  })

  return (
    <div className='precedents-view content-view'>
      <div className='layout-width-constraint'>
        <ResponseConsumer
          response={response}
          content={() => (
            <>
              <header className='f3 b black pt7 pb6 ml6'>
                {sectionTitle}
              </header>
              <PrecedentsReviewSections {...{ title, sectionId, category, response, filteredParents, nodes }} />
            </>
          )}
        />
      </div>
    </div>
  )
}
